<div class="ghost-title" [ngClass]="size"></div>
